var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterPravilaPonasanja(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7,.cls-8{fill:none;}.cls-1{stroke:#159497;}.cls-1,.cls-6,.cls-7,.cls-8{stroke-miterlimit:10;stroke-width:1.5px;}.cls-2{fill:#aa6276;}.cls-3{fill:#fa7268;}.cls-4{fill:#6e5dd8;}.cls-5{fill:#159497;}.cls-6{fill:#fff;}.cls-6,.cls-8{stroke:#aa6276;}.cls-7{stroke:#000;stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 301.75,
    cy: 161.33,
    rx: 256.7,
    ry: 114.39,
    transform: "translate(-29.41 75.21) rotate(-13.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 436.7,
    cy: 115.76,
    r: 16.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 423.01,
    cy: 89.27,
    r: 30.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M445.25,80.74c4.45-.57,9-1.5,12.81-3.83s6.92-6.31,7.16-10.8A10.82,10.82,0,0,0,449.35,56a17.79,17.79,0,0,0-28.88-9c-5.53-3.92-12.77-5.68-19.3-3.87s-12.06,7.48-12.9,14.21C385.12,82.65,430.59,82.62,445.25,80.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.12,127.77a63.59,63.59,0,0,1,3.35-54.35c5.7-2.19,11.7,1.52,14,7.18a12.24,12.24,0,0,1-6.39,15.25,10.78,10.78,0,0,1,6.44,18.22,11.91,11.91,0,0,1-1.65,14.18C459.24,131.9,451.52,130.41,447.12,127.77Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 421.96,
    cy: 77.99,
    r: 9.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 438.43,
    cy: 82.19,
    r: 13.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146.04,
    cy: 207.65,
    r: 5.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 67.23,
    cy: 58.96,
    r: 5.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.14,
    cy: 89.27,
    r: 1.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 52.54,
    y: 234.45,
    width: 14.69,
    height: 14.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "532.55 272.92 537.55 264.26 527.55 264.26 532.55 272.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M373.71,117.65s39.61,4.93,68,26.31c37.72,28.37,33.34,66.72,30.94,80.79-2.17,12.72-10.31,24.07-30.51,33.09s-52,10.75-52,10.75l-6.45-28.37s15.66-2.07,28.52-4.86a94.16,94.16,0,0,0,12.1-3.3c11.38-4.3,18.26-10.75,17.83-23.64s-15.5-25.78-15.5-25.78S416,227.76,406.51,245s-9.46,15-9.46,15l-23.34.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 393.32,
    cy: 93.15,
    r: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 201.41,
    y: 28.95,
    width: 172.3,
    height: 270.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.81,126.45a6,6,0,0,1-.33,9.42,7.41,7.41,0,0,1-8.82,11.76,12,12,0,0,1-4.5-5.44c-3.64-7.49-5.52-23,2.7-28.61C200.89,108.15,210.59,119.25,203.81,126.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M407.08,104.67a4.54,4.54,0,0,1-6.43,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 445.25,
    cy: 102.86,
    r: 11.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 464.51,
    cy: 102.86,
    r: 11.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 460.99,
    cy: 82.96,
    r: 11.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 397.2,
    cy: 72.78,
    r: 9.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,58.68c7.31,0,7.31-1,14.61-1s7.31,1.11,14.61,1.11,7.31-.65,14.61-.65,7.31,1.41,14.62,1.41,7.3.49,14.61.49,7.3-.86,14.61-.86,7.31-.76,14.61-.76,7.31.34,14.62.34,7.31-1,14.62-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,77.61c7.49,0,7.49,0,15,0s7.49.6,15,.6,7.49.47,15,.47,7.49.14,15,.14,7.49-1.28,15-1.28,7.49,1.11,15,1.11,7.49-.32,15-.32,7.49-.86,15-.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,97c6.8,0,6.8,1,13.6,1s6.8-.54,13.61-.54,6.8-1.68,13.6-1.68,6.8.79,13.6.79,6.8,1.18,13.6,1.18,6.8-.13,13.61-.13,6.8-.38,13.6-.38,6.81-.22,13.61-.22,6.81,1,13.62,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,115.76c7.31,0,7.31.19,14.61.19s7.31,1,14.61,1,7.31-1.62,14.61-1.62,7.31.51,14.62.51,7.3-1,14.61-1,7.3,1.86,14.61,1.86,7.31-.24,14.61-.24,7.31-1.42,14.62-1.42,7.31,2.31,14.62,2.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,135.81c7.49,0,7.49-.54,15-.54s7.49.24,15,.24,7.49-.41,15-.41,7.49-.92,15-.92,7.49-.2,15-.2,7.49,1.51,15,1.51,7.49-1.35,15-1.35,7.49,1.33,15,1.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,154.76c6.85,0,6.85-.46,13.69-.46s6.85-.93,13.69-.93,6.85,1,13.69,1,6.85-1,13.69-1,6.85-.1,13.7-.1,6.84.74,13.69.74,6.85-.7,13.7-.7l13.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,174.16c7.31,0,7.31-.19,14.61-.19s7.31-1.63,14.61-1.63,7.31.4,14.61.4H278c7.3,0,7.3,1,14.61,1s7.3-1.26,14.61-1.26,7.31.13,14.61.13,7.31.79,14.62.79,7.31-1.07,14.62-1.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,192.79c6.8,0,6.8-1.79,13.6-1.79s6.8.87,13.61.87,6.8.53,13.6.53,6.8-.39,13.6-.39,6.8-.36,13.6-.36,6.8,1.37,13.61,1.37,6.8.07,13.6.07,6.81-.42,13.61-.42,6.81-.48,13.62-.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,210.17c7.31,0,7.31.41,14.61.41s7.31.91,14.61.91,7.31-1,14.61-1,7.31.9,14.62.9,7.3-.44,14.61-.44,7.3-.09,14.61-.09,7.31,1.25,14.61,1.25,7.31-1.34,14.62-1.34,7.31,1.57,14.62,1.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,231.51c7.31,0,7.31-1.63,14.61-1.63s7.31.44,14.61.44,7.31-.11,14.61-.11,7.31.54,14.62.54,7.3-1,14.61-1,7.3.43,14.61.43,7.31-.23,14.61-.23,7.31.17,14.62.17,7.31.46,14.62.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.52,249c7.31,0,7.31-.64,14.61-.64s7.31,1.64,14.61,1.64h14.61c7.31,0,7.31-.91,14.62-.91s7.3.09,14.61.09,7.3-.52,14.61-.52,7.31-.34,14.61-.34,7.31.58,14.62.58,7.31.13,14.62.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.79,267.75l-5.2-22.92s-18.09-5.31-21.22-4.83-2.9,3.86,0,6.27a26.21,26.21,0,0,0,4.34,3.13s-22.18-4.33-24.11-2.41-2.41,4.83,0,6.27,15.72,3.14,15.72,3.14a29.1,29.1,0,0,0,.43,8.68c1,4.58,7.52,10.6,13.55,8.95C376.79,273.07,389.79,267.75,389.79,267.75Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPravilaPonasanja);
export default __webpack_public_path__ + "static/media/Footer-pravila_ponasanja.b9deef429bc17ad7beb31caf45f8453d.svg";
export { ForwardRef as ReactComponent };